<template>
  <master-page>
    
        <v-card class="mt-4">

          <v-card-title class="pa-0 sticky">
            <v-toolbar color="primary">

              <v-toolbar-title>
                <v-icon large left color="white">mdi-cog</v-icon>
                <span class="title font-weight-light" style="color: white">Cadastro Parâmetros do Sistema</span>
              </v-toolbar-title>

              <v-spacer/>

              <v-toolbar-items>
                <v-btn color="white" class="pr-2" text @click="Salvar()" :disabled="!valid">Salvar</v-btn>
              </v-toolbar-items>

              <template v-slot:extension>
                <v-tabs v-model="tabActive" color="secondary">
                  <v-tab>Geral</v-tab>
                  <v-tab>Cobrança</v-tab>
                  <v-tab>NFS-e</v-tab>
                  <v-tab>Beneficiário</v-tab>
                  <v-tab>Doador</v-tab>
                  <v-tab>Pessoal</v-tab>
                </v-tabs>
              </template>             
            
            </v-toolbar>
          </v-card-title>

          <v-card-text class="my-3">

            <v-tabs-items v-model="tabActive">

              <v-tab-item>
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-switch v-model="item.doadorGrupoObrigatorio" label="Doador Grupo Obrigatório" dense/>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Envio dos boletos</legend>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.smtp" label="SMTP" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.porta" label="Porta" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.usuario" label="Usuário" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="item.senha" label="Senha" :counter="25" maxlength="25" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="2" sm="2">
                      <v-switch v-model="item.usarSSL" label="Usar SSL" style="margin-top: 5px" dense/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.email" label="E-mail" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.assunto" label="Assunto" :counter="45" maxlength="45" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
                <fieldset class="pa-4">
                  <legend>Instruções do Boleto</legend>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.juros" label="Juros(%)" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="item.multa" label="Multa(%)" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="item.instrucao1" label="Instrução 1" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="item.instrucao2" label="Instrução 2" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="item.instrucao3" label="Instrução 3" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Informações para gerar nota de serviço eletrônica</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-switch style="margin-top: 5px" v-model="item.producaoNFse" :label="`Ambiente: ${item.producaoNFse ? 'Produção' : 'Homologação'}`" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field v-model="item.certificado" label="Certificado (Serial)" :counter="35" maxlength="35" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field type="password" v-model="item.certificadoSenha" label="Senha" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-text-field v-model="item.codigoServico" label="Código Serviço" :counter="10" maxlength="10" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                      <v-text-field v-model="item.codigoTributacaoMunicipio" label="Código Tributação" :counter="25" maxlength="25" dense outlined/>
                    </v-col>                    
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="item.textoNFSe" label="Texto padrão" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Nome para os campos personalizados</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo04" label="Campo 4" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo05" label="Campo 5" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo06" label="Campo 6" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo07" label="Campo 7" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo08" label="Campo 8" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo09" label="Campo 9" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo10" label="Campo 10" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo11" label="Campo 11" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo12" label="Campo 12" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo13" label="Campo 13" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo14" label="Campo 14" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="item.beneficiarioCampo15" label="Campo 15" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Nome para os campos personalizados</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.doadorCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.doadorCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.doadorCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.doadorCampo04" label="Campo 4" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.doadorCampo05" label="Campo 5" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Pessoal</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.pessoalCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.pessoalCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="item.pessoalCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

            </v-tabs-items>

          </v-card-text>

        </v-card>

    <v-overlay :value="primeiraCarga">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </master-page>
</template>

<script>
import Parametro from '../../../core/domain/geral/Parametro';
import { ParametroService } from '../../../core/services/geral';

export default {

  data:() => ({
    tabActive: null,
    valid: true,
    service: new ParametroService(),
    item: new Parametro(),
    primeiraCarga: true
  }),
  methods: {
    Atualizar(){
      this.primeiraCarga = true;
      this.service.ListarTudo().then(
        res=>{
          this.item = res.data.items[0]
        },
        err=>{
          this.$swal('Aviso', err.message, 'error');
        }
      ).finally(() =>{
        this.primeiraCarga = false;
      })
    },
    Salvar(){
      this.service.Salvar(this.item).then(
        res => {
          this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
          this.$emit('salvou');
        }, 
        err =>  {
          if (err.response.status == 400) {
            this.$swal('Aviso', err.response.data.title, 'warning')    
          }
          else {
            this.$swal('Aviso', err.response.data, 'error')
          }
        }
      )
    }
  },
  mounted() {
    this.Atualizar()
  }
}
</script>

<style>
  .sticky{
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 5;
  }
</style>